import { Rotate90DegreesCcw } from '@material-ui/icons';
import styled, {css} from 'styled-components';
import {Section,BtnFlex, Btn, Container, Grid, SectionSubTitle, SectionTitle} from '../ReUsableStyles';


export const SkillsSection = styled.section`
    ${Section};
`;

export const Title = styled.h2`
    ${SectionTitle};

`;

export const Subtitle = styled.span`
    ${SectionSubTitle};
`;

export const SkillsContainer = styled.div`
    ${Container};
    ${Grid};
    row-gap: 0;
`;

export const Content = styled.div`

   
`;

export const SkillsHeader = styled.div`
    display:flex;
    align-items: center;
    margin-bottom: var(--mb-2-5);
    cursor: pointer;

    .skills__icon, .skills__arrow{
        color: var(--first-color);
    }
    .skills__icon{
        margin-right: var(--mb-0-75);
    }
    .skills__arrow{
        margin-left: auto;
        transition: .4s;
    }
    // .front, .back{
    //     // transform: ${(props)=> props.open && "rotate(-180deg)"};
    // }
`;

export const SkillsTitle = styled.h1`
    font-size: var(--h3-font-size);
`;

export const SkillsSubtitle = styled.span`
    font-size: var(--small-font-size);
    color: var(--text-color-light);
`;

export const SkillsList = styled.div`
    ${Grid};
    row-gap: 1.5rem;
    padding-left: 2.7rem;

    &.backend,&.frontend{
        height: ${(props) => props.open? "max-content": "0"};
        overflow: ${(props) => !props.open && "hidden"};
        margin-bottom: var(--mb-2-5);
        transition: 1s;
    }; 
`;

export const SkillsData = styled.div`
    
`;

export const MainSkillTitle = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: var(--mb-0-5);
`;

export const SkillsName = styled.h3`
    font-size: var(--normal-font-size);
    font-weight: var(--font-medium);
`;

export const SkillsNumber = styled.span`
    
`;

const SkillsBarAndPercent = css`
    height: 5px;
    border-radius: .25rem;
`;
export const SkillsBar = styled.div`
    ${SkillsBarAndPercent};
    background-color: var(--first-color-lighter);
`;
export const SkillsPercentage = styled.span`
    ${SkillsBarAndPercent};
    display:block;
    background-color: var(--first-color);
    width: ${props => props.width +"%"};
`;